export default "__VITE_ASSET__uAlW83Jc__"